// extracted by mini-css-extract-plugin
export default {"container":"TabletDiagram_container__tBSSo","wrapperBar":"TabletDiagram_wrapperBar__HKXKV","barChart":"TabletDiagram_barChart__ng+ZV"};